// extracted by mini-css-extract-plugin
module.exports = {"textarea":"Chat_textarea__3Zbbs","textareaContainer":"Chat_textareaContainer__3--em"};